import React from 'react';

export function CashGiftGuideStyles() {
  return (
    <style>{`
    .refer-earn-cash-gift-visual {
      transform-origin: 50% 82%;
    }
    .refer-earn-cash-gift-effects-layer {
      transition-property: opacity, filter;
      transition-duration: 180ms;
      transition-timing-function: ease-out;
    }
    .refer-earn-cash-gift-idle-settling {
      animation: none;
      transform: none;
      transition: transform 120ms ease-out;
      will-change: transform;
    }
    .refer-earn-cash-gift-effects-layer,
    .refer-earn-cash-gift-guide {
      opacity: 1;
      transition-property: opacity, transform;
      transition-timing-function: ease-out;
    }
    .refer-earn-cash-gift-effects-dismissing {
      opacity: 0;
    }
    .refer-earn-cash-gift-effects-dismissing *,
    .refer-earn-cash-gift-effects-dismissing *::before,
    .refer-earn-cash-gift-effects-dismissing *::after {
      animation-play-state: paused;
    }
    .refer-earn-cash-gift-guide-dismissing {
      opacity: 0;
      transform: translate(-50%, -50%) scale(1.35);
    }
  `}</style>
  );
}
